import { almostZero } from "@xola/ui-kit";
import { isMistPurchase } from "common";
import { Purchase, PurchaseItem } from "types";
import { RefundOption } from "./RefundOption";

// Route by whether the cancelled item still has value to reduce; fall back to the whole purchase for a cancel-all.
export const getRefundOptionAfterCancel = (purchase: Purchase, item?: PurchaseItem): RefundOption => {
    const isReducedToZero = item ? almostZero(item.amount) : almostZero(purchase.amount);

    if (isReducedToZero) {
        return RefundOption.RETURN_PAYMENT;
    }

    // > 0.01 so a rounding residue (a stray cent) isn't treated as an owed balance
    if (purchase.balance > 0.01) {
        return RefundOption.REDUCE;
    }

    return purchase.splitPayment.enabled ? RefundOption.RETURN_PAYMENT : RefundOption.REDUCE_AND_RETURN;
};

// MIST: when the cancelled item has no value left to refund, return the purchase-level overpayment
// instead of the item-scoped modal, which would cap the refund at $0.
export const shouldReturnExcessAtPurchaseLevel = (
    purchase: Purchase,
    item: PurchaseItem | null | undefined,
    selectedRefundOption: RefundOption | null,
): boolean =>
    isMistPurchase(purchase) &&
    selectedRefundOption === RefundOption.RETURN_PAYMENT &&
    !!item &&
    almostZero(item.amount);
